import { useParams } from 'react-router'
import { Create, Edit, EditButton, List, Show, TopToolbar, useResourceContext } from 'react-admin'

import { Box, Link, Text } from '../../../components'
import { camelToTitleCase } from '../../../utils'
import { ToolbarProvider } from '../toolbar/ToolbarContext'

function title(resource) {
  if (resource === 'MFund') return 'Funds'
  if (resource === 'Charity') return 'Charities'
  if (resource === 'Grant') return 'Gift Disbursement'
  if (resource === 'GrantRequest') return 'Gift Request'
  if (resource === 'RecurrentGrantRequest') return 'Recurrent Gift Request'
  if (resource === 'MProfile') return 'Profiles'
  if (resource === 'DafTransfer') return 'Share Funds'
  if (resource === 'ManagingUserOnFund') return 'Roles'
  if (resource === 'RecurrentDafTransfer') return 'Recurring Share Funds'
  if (resource === 'RbacUserRole') return 'Portals'
  return `${camelToTitleCase(resource)}s`
}

function TitleLink({ children, ...props }) {
  return (
    <Link sx={{ fontWeight: '600' }} {...props}>
      {children}
    </Link>
  )
}

export function RaCreate({ ...props }) {
  const resource = useResourceContext()
  return (
    <>
      <Text.H1 sx={{ mb: 2 }}>
        <TitleLink to={`/management/${resource}`}>{title(resource)}</TitleLink> / {props.label || 'Create'}
      </Text.H1>
      <Create {...props} />
    </>
  )
}

export function RaList({ filters, titleActions, ...props }) {
  const resource = useResourceContext()
  return (
    <ToolbarProvider filters={filters}>
      <Box
        sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 2, pr: titleActions ? 3 : 0 }}
      >
        <Text.H1 sx={{ mb: 0 }}>
          <TitleLink to={`/management/${resource}`}>{title(resource)}</TitleLink>
        </Text.H1>
        {titleActions}
      </Box>
      <List filters={filters} {...props} />
    </ToolbarProvider>
  )
}

const DefaultShowActions = (
  <TopToolbar sx={{ justifyContent: 'flex-start' }}>
    <EditButton />
  </TopToolbar>
)

export function RaShow({ actions = DefaultShowActions, ...props }) {
  const { id = '' } = useParams()
  const resource = useResourceContext()
  return (
    <>
      <Text.H1 sx={{ mb: 2 }}>
        <TitleLink to={`/management/${resource}`}>{title(resource)}</TitleLink> / #{id}
      </Text.H1>
      <Show actions={actions} {...props} />
    </>
  )
}

export function RaEdit({ ...props }) {
  const { id = '' } = useParams()
  const resource = useResourceContext()
  return (
    <Box className="edit-page">
      <Text.H1 sx={{ mb: 2 }}>
        <TitleLink to={`/management/${resource}`}>{title(resource)}</TitleLink> /{' '}
        <TitleLink to={`/management/${resource}/${id}/show`}>#{id}</TitleLink> / Edit
      </Text.H1>
      <Edit {...props} />
    </Box>
  )
}
